module.exports = __webpack_public_path__ + "static/media/teke-fum-m-o.50e691f3.jpg";